export default {"src":"/_next/static/media/TWO.c20a56fc.svg","height":18,"width":18};